export default __webpack_public_path__ + "static/media/team.302da02b.PNG";